module.exports = __webpack_public_path__ + "img/api-gateway.0d110b55.svg";